import { IVerticalizedImageryInSignUpXP } from '@faire/web-api--source/indigofair/data/IVerticalizedImageryInSignUpXP';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * Relaunch show verticalized imagery in sign up XP
 * https://www.notion.so/faire/Verticalized-Imagery-in-Signup-12e2efb5c25a80aab1abdb96e0e00c8f
 */
export const VERTICALIZED_IMAGERY_IN_SIGN_UP_RELAUNCH_250127 =
  'VERTICALIZED_IMAGERY_IN_SIGN_UP_RELAUNCH_250127' as SettingConst<
    'VERTICALIZED_IMAGERY_IN_SIGN_UP_RELAUNCH_250127',
    keyof typeof IVerticalizedImageryInSignUpXP.Bucket,
    'RETAILER' | 'VISITOR_WEB'
  >;
